import React, { Component } from 'react';
import Footer from "./footer2";
import Header from "./header";
import { Helmet } from "react-helmet";
import axios from "axios";
import DOMPurify from "dompurify";

class datenschutz extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      value: '',
      Admin_user_id: 12898
    };
  }
  componentDidMount() {
    console.log("test")
    axios
      .post('/api/GetEditorContact', this.state)
      .then(response => {
        //console.log(response)
        const value = response.data.result[0].EditorDesc;
        console.log(value)
        this.setState({ value })
        //this.setState({adduser_err:undefined})
        //   var adduser_succ = response.data.msg;
        //   this.setState({ adduser_succ })
      })
      .catch(error => {
        console.log(error.response);
        //   this.setState({adduser_succ:undefined})
        //   var adduser_err = error.response.data.msg
        //   this.setState({ adduser_err })
      })
  }
  render() {
    return (
      <div>
        <Helmet>
          <title>Hello-Sister | Kontakt</title>
          <meta name="Description" content="Hello-Sister - Jobs für Krankenpfleger, Altenpfleger, Fachkrankenschwester, MTRA, Psychologen, Stellenangebote im Gesundheitswesen" data-react-helmet="true" />
        </Helmet>

        {/* Header */}
        <Header></Header>

        <h1 style={{
          textAlign: 'center',
          marginTop: '36px'
        }}>Kontakt</h1>

        {/*//End Header */}
        {/*==================== Contact ====================*/}
        <section className="space-mb">
          <div className="container container-custom">
            <div className="row">
              <div className="col-md-6">
                <div className="video-play-text">
                  <h3>Melden Sie sich ganz einfach telefonisch oder per Email bei uns.</h3>
                  <br />
           
                  <p
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(this.state.value),
                    }}
                  ></p>
                  {/* <ul className="nav-icon-wrap">
                    <hr />
                    <li className="nav-item" style={{fontSize: "17px"}}>
                      <i className="fas fa-envelope-open-text"> <a href="mailto:kunden@guel.gmbh">
                                      kunden@guel.gmbh
                                    </a></i>
                    </li>
                    <br />
                    <li className="nav-item" style={{fontSize: "17px"}}>
                 
                      <i className="fas fa-phone-square"><a href="tel:+4968168635374">
                                      +49 (681) 68 63 53 74
                                    </a></i>
                    </li>
                    <br />
                    <li className="nav-item" style={{fontSize: "17px"}}>
                      <i className="fab fa-whatsapp-square"><a href="https://wa.me/491624970162" target="_blank" rel="noopener noreferrer">
                                      +49 (162) 49 70 162
                                    </a></i>
                    </li>
                 <br />
                    <li className="nav-item" style={{fontSize: "17px"}}>
                      <i className="fab fa-chrome">  https://www.hello-sister.de</i>
                    </li>
                    <br />
                    <li className="nav-item" style={{fontSize: "17px"}}>
                      <i className="fas fa-map-marker-alt">   Gül GmbH - An der Trift 40 - 66123 Saarbrücken - Germany</i>
                    </li>
                  </ul> 
                  */}
                  <hr />

                  <div>
                    <h3>Scan me</h3>
                    <img src="../img2/qrcode.jpeg" />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="news-img-block">
                  <br />
                  <img src="../img2/contact-us.png" className="img-fluid" alt="#" width="700px" />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*//End News */}


        {/* Footer */}

        <Footer></Footer>

      </div>

    )
  }
}

export default datenschutz